<template>
  <div class="page">
    <!-- 头部 -->
    <Header title="我的订单" :leftHandler="onClickLeft" />
    <van-tabs v-model="pageInfo.orderStatus" class="van-tabs" @change="slideHasChanged" swipeable>
      <van-tab v-for="tab in tabOption" :title="tab.title" :name="tab.name" :key="tab.name"></van-tab>
    </van-tabs>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
        <div class="margin-x-2" v-for="(order,index) in orderList" :key="index" >
          <!-- 未拆分 -->
          <template v-if="order.baseInfo.splitStatus == '01'">
            <div class="row">
              <p>订单编号</p>
              <p>创建时间</p>
            </div>
            <div class="row">
              <p>{{ order.baseInfo.orderNumber }}</p>
              <p>{{ order.baseInfo.orderDate | parseTime('{y}-{m}-{d}') }}</p>
            </div>
            <div v-for="(detailItem, index) in order.detailList" :key="index" @click="goToDetail(detailItem.orderId)">
              <OrderDetailBox :detailItem="detailItem" :orderInfo="order"  height="2rem"
                @cancelOrder="orderCancel(detailItem.itemId, detailItem.orderId, detailItem.orderDetailId, $event)"
                @openElearning="openElearning(detailItem.itemId,detailItem.orderId, detailItem.orderDetailId, $event)" >
              </OrderDetailBox>
            </div>
          </template>
          <!-- 拆分中或已拆分 -->
          <template v-if="order.baseInfo.splitStatus == '02' || order.baseInfo.splitStatus == '03'">
            <div class="row">
              <p>订单编号</p>
              <p>订单拆分</p>
              <p>创建时间</p>
            </div>
            <div class="row">
              <p>{{ order.baseInfo.orderNumber }}</p>
              <p> {{ order.baseInfo.splitStatusName }}</p>
              <p>{{ order.baseInfo.orderDate | parseTime('{y}-{m}-{d}') }}</p>
            </div>
            <!-- 子订单 -->
            <div v-for="(subOrders, index) in order.subOrderList" :key="index">
              <div class="row">
                <p>子订单编号</p>
              </div>
              <div class="row">
                <p>{{ subOrders.baseInfo.orderNumber }}</p>
              </div>
              <div v-for="(subOrderItem, index) in subOrders.detailList" :key="index"
                @click="goToDetail(subOrderItem.orderId)">
                <OrderDetailBox :detailItem="subOrderItem" :orderInfo="orderList" height="2rem"
                  @cancelOrder="orderCancel(subOrderItem.itemId, subOrderItem.orderId, subOrderItem.orderDetailId, $event)"
                  @openElearning="openElearning(subOrderItem.itemId, subOrderItem.orderId, subOrderItem.orderDetailId, $event)"
                  >
                </OrderDetailBox>
              </div>
            </div>
          </template>
          <div class="order-item-bottom"></div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import Header from '@/components/header'
import cartApi from '@/api/cart'
import OrderDetailBox from './component/order-detail-box.vue'
import { mapState } from 'vuex'
export default {
  components: {
    Header,
    OrderDetailBox
  },
  data () {
    return {
      model: {
        activeIndex: 0
      },
      hasMore: true,
      orderList: [],
      pageInfo: {
        page: 1,
        pageSize: 5,
        orderStatus: '-1'
      },

      tabOption: [{
        title: '全部',
        name: '-1'
      }, {
        title: '待发货',
        name: '10'
      }, {
        title: '已发货',
        name: '30'
      }, {
        title: '已完成',
        name: '50'
      }, {
        title: '已退回',
        name: '35'
      }, {
        title: '再发货',
        name: '40'
      }],
      loading: false,
      finished: false,
      refreshing: false
    }
  },
  computed: {
    ...mapState({
      userRole: state => state.user.userRole, // 01老板，02采购，03小工
      clientInfo: state => state.user.clientInfo
    })
  },
  created () {
    if (this.userRole === '03') {
      this.$toast('没有查看订单的权限')
    } else {
      this.init()
    }
  },
  methods: {
    init () {
      this.slideHasChanged()
    },
    slideHasChanged () {
      this.refreshing = true
      this.onRefresh()
    },
    // 到底加载
    onLoad () {
      if (this.refreshing) {
        this.refreshing = false
        this.pageInfo.page = 1
        this.orderList = []
      }
      const params = {
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        orderStatus: this.pageInfo.orderStatus === '-1' ? '' : this.pageInfo.orderStatus
      }
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      cartApi.getOrderList(params).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          const { orderList } = res.data.resultData
          if (orderList && orderList.length) {
            this.orderList = this.orderList.concat(orderList)
          } else {
            this.finished = true
          }
          this.loading = false
          this.pageInfo.page++
        }
      }).catch(() => { this.$toast.clear() })
    },
    // 下拉刷新
    onRefresh () {
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    orderCancel (itemId, orderId, orderDetailId) {
      this.$router.push({
        name: 'orderCancel',
        params: {
          itemId: itemId,
          orderId: orderId,
          orderDetailId: orderDetailId
        }
      })
    },
    openElearning (itemId, orderId, orderDetailId) {
      console.log(itemId, '父组件')
      this.$router.push({
        name: 'knowledge-goods',
        params: {
          itemId: itemId,
          orderId: orderId,
          orderDetailId: orderDetailId
        }
      })
    },
    onClickLeft () {
      this.$router.push({
        name: 'center'
      })
    },
    goToDetail (orderId) {
      this.$router.push({
        name: 'orderDetail',
        params: {
          orderId: orderId
        }
      })
    }
  }
}
</script>
<style  scoped lang="less">
.van-tabs {
  position: fixed;
  width: 100%;
  height: 1.2rem;

  /deep/ .van-tabs__content {
    min-height: auto;
  }
}

.van-pull-refresh {
  margin-top: 1.2rem;
}

.margin-x-2 {
  margin: 0.2rem 0rem;
}

.row {
  display: flex;
  align-items: center;
  // text-align: center;
  padding: 0.1rem 0rem;
  font-size: 0.35rem;
  justify-content: space-around;
  p {
    // flex: 0 0 50%
  }
}

.order-item-bottom {
  width: 100%;
  height: 0.25rem;
  // padding-right: 0.3rem;
  // padding-top: 0.2rem;
  text-align: right;
  font-size: 0.2rem;
  background-color: #fff;
}
</style>
